export default "__VITE_ASSET__f400a1c0__"